"use client";

export {
  SafeEmailBody,
  type SafeEmailBodyProps,
  type SafeEmailBodyVariant,
  type PrepareMarkupOptions,
} from "./safe-email-body";
